// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"2397cf5d","382":"04bc8008","461":"51190890"}[chunkId] + ".chunk.css";
};